import * as React from 'react';
import { scrollTo } from '../utils';

export function useScrollTo(elementId: string): () => void {
  const elementRef = React.useRef<HTMLElement | null>(null);

  return React.useCallback(() => {
    if (!elementRef.current) {
      elementRef.current = document.getElementById(elementId);
    }

    if (elementRef.current) {
      scrollTo(elementRef.current);
    }
  }, [elementId]);
}
